import { ArrowIcon } from "../../../assets/icons"; 

export const workerCardButtons = [
    {
        path: `motivation`,
        text: "Установить план для сотрудника",
        icon: <ArrowIcon />,
        type: "secondary"
    },
    {
        path: `tasks`,
        text: "Задачи сотрудника",
        icon: <ArrowIcon />,
        type: "secondary"
    },
    {
        path: `table`,
        text: "Табель сотрудника",
        icon: <ArrowIcon />,
        type: "secondary"
    },
    {
        path: "reports",
        text: "Отчеты по чек-листам",
        icon: <ArrowIcon />,
        type: "secondary"
    },
]
